<template>
	<v-card>
		<v-card-title>
			<div><span class="headline">مدیریت لیست سازمان ها</span></div>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<div>
				<div>
					<div v-if="!items.length">
						<h3 class="text-center red--text">لیست سازمان ها خالی است</h3>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="green" dark @click="add">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن سازمان
							</v-btn>
						</div>
					</div>
					<div v-else>
						<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3" elevation="0" style="border: 1px solid #dca6e5">
							<div class="pa-2 d-flex align-center">
								<div style="flex-grow: 2;">
									<div class="grey--text" v-if="!item.editMode"><small>نام سازمان:</small></div>
									<div class="" v-if="!item.editMode">{{ item.name }}</div>
									<v-text-field class="pt-2" dense v-if="item.editMode" v-model="item.name" label="نام سازمان" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام سازمان را وارد کنید']" required />
								</div>
								<div>
									<v-btn v-if="!item.editMode" @click="edit(item)" class="ms-2 ml-1" x-small fab dark color="secondary" title="ویراش">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn v-if="!item.editMode" @click="remove(item, index)" class="ms-2 ml-1" x-small fab dark color="pink" title="حذف">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
									<v-btn :loading="submitLoading" @click="save(item, index)" class="ms-2 ml-1" title="ذخیره" v-if="item.editMode" color="success" fab x-small dark>
										<v-icon dark>
											mdi-check
										</v-icon>
									</v-btn>
									<v-btn class="ms-2 ml-1" @click="cancel(item, index)" v-if="item.editMode" title="انصراف" color="grey" fab x-small dark>
										<v-icon dark>
											mdi-close
										</v-icon>
									</v-btn>
								</div>
							</div>
						</v-card>
						<div class="text-center mt-5">
							<v-btn class="mx-auto" color="green" dark @click="add">
								<v-icon dark>
									mdi-plus-circle-outline
								</v-icon>
								افزودن سازمان جدید
							</v-btn>
						</div>
					</div>
				</div>

				<confirm-dlg ref="confirm" />
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'

	export default {
		name: 'Organizations',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				errorMessages: '',
				items: [],
				submitLoading: false,
				loading: false,
			}
		},
		computed: {
		},
		mounted() {
			this.loadData()
		},
		methods: {
			fetchOrganizations: call('organizations/fetch'),
			loadData(force = false) {
				this.fetchOrganizations({ force: force }).then(items => {
					this.items = _.cloneDeep(items).map(x => {
						x.editMode = false
						return x
					})
				})
			},
			edit(item) {
				item.editMode = true
				item.original = JSON.parse(JSON.stringify(item))
			},
			save(item, index) {
				if (!item.name) {
					toast.error('نام سازمان وارد نشده است.')
					return
				}
				this.submitLoading = true
				var clone = { ...item }
				api.post('admin/organization/' + (item.id === emptyId ? 'create' : 'edit'), clone)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						item.editMode = false
						this.loadData(true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(item, index) {
				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}
				item.name = item.original?.name
				item.editMode = false
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/organization/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData(true)
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				let newItem = {
					id: emptyId,
					name: '',
					editMode: true,
				}
				this.items.push(newItem)
			},
		},
	}
</script>
<style></style>
